var _circle, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabManager(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 650 650",
    style: {
      enableBackground: "new 0 0 650 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 182.7,
    r: 154.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M629.5,578.6L534.8,420c-4.4-7.4-6.8-15.9-6.8-24.5V325h-50.4v70.5c0,8.6-2.3,17.1-6.8,24.5l-94.7,158.6 c-8,13.4,1.7,30.5,17.3,30.5h218.7C627.8,609.1,637.5,592,629.5,578.6z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339.3,579.3L444.5,403c4.9-8.2,7.5-17.6,7.5-27.2v-53.2c-4.9-4.2-10-8.1-15.2-11.9c-35.1,37.2-84.7,60.4-139.9,60.4 c-55.1,0-104.8-23.2-139.9-60.4c-60.5,43.5-99.8,114.5-99.8,194.7c0,11.8,0.9,23.4,2.5,34.8c69.8,40.3,150.8,63.4,237.2,63.4 c14.2,0,28.2-0.6,42-1.8C335.4,595.1,334.9,586.7,339.3,579.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabManager);
export default __webpack_public_path__ + "static/media/LabManager.ac9b7cfa.svg";
export { ForwardRef as ReactComponent };